import { createRouter, createWebHistory } from 'vue-router';
import HomeView from '../views/HomeView.vue';
import TeachView from '../views/TeachView.vue';
import ProjectsView from '../views/ProjectsView.vue';
import ContactView from '../components/ContactView.vue';
import ResumeTimeline from '../components/ResumeTimeline.vue';
import NotFoundView from '../views/NotFoundView.vue';

const routes = [
  {
    path: '/',
    component: HomeView,
    meta: { title: 'Jerome Brown — Product Leader & Builder' },
  },
  {
    path: '/projects',
    component: ProjectsView,
    meta: { title: 'Products — Jerome Brown' },
  },
  {
    path: '/teach',
    component: TeachView,
    meta: { title: 'Learn AI with Jerome — Beginner to Explorer' },
  },
  {
    path: '/about',
    component: ResumeTimeline,
    meta: { title: 'About — Jerome Brown' },
  },
  {
    path: '/contact',
    component: ContactView,
    meta: { title: 'Contact — Jerome Brown' },
  },
  {
    path: '/:pathMatch(.*)*',
    component: NotFoundView,
    meta: { title: 'Page Not Found — Jerome Brown' },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0, behavior: 'smooth' };
  },
});

router.afterEach((to) => {
  document.title = to.meta.title || 'Jerome Brown — Product Leader & Builder';
});

export default router;
